import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#241622] px-5 py-20" data-id="element-84" data-mp="4vjoa88mncgq">
      <div className="mx-auto max-w-3xl rounded-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-85" data-mp="9tthweepe508">
        <p className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-86" data-mp="eu8tb0ffd2fk">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-87" data-mp="nu49xkrr1pmz" />
          Zero rischi · 100% protetto
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-88" data-mp="skufay06dsho" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#241322] sm:text-6xl" data-id="element-89" data-mp="xjxmop3moast">
          Garanzia di <span className="text-emerald-700" data-id="element-90" data-mp="12jjxkrvzheyg">7 giorni</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-91" data-mp="12h7ay1fa6gf2">
          Apri tutto. Usa il materiale nelle tue lezioni di Pilates.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#241322]" data-id="element-92" data-mp="25ti5kiflimzh">
          Se Pilates Pronta non trasforma il modo in cui pianifichi e gestisci
          il tuo Studio,{' '}
          <span className="text-emerald-700" data-id="element-93" data-mp="1vuitepvmg97q">
            ti rimborseremo ogni centesimo — senza domande.
          </span>
        </p>
        <p className="mt-4 text-sm font-medium text-slate-600" data-id="element-94" data-mp="1ru8qjm34lyx3">
          I bonus restano tuoi come ringraziamento per averci provato.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#241322]" data-id="element-95" data-mp="2jj20j22xqfy8">
          <span className="flex items-center gap-1.5" data-id="element-96" data-mp="2erk1ijkh2pfw">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-97" data-mp="2ar04rh3t9nua" />
            Rimborso semplice
          </span>
          <span className="flex items-center gap-1.5" data-id="element-98" data-mp="378wg3ren2im6">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-99" data-mp="37ah7j85nplft" />
            Nessun modulo da compilare
          </span>
          <span className="flex items-center gap-1.5" data-id="element-100" data-mp="32g3c55qzveb5">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-101" data-mp="10lp0abj5198c" />I bonus restano
            tuoi
          </span>
        </div>
        <a href="https://pilates-pronta.impultienda.ar/checkout" className="cta-button mx-auto mt-9 flex w-full max-w-md items-center justify-center rounded-2xl px-6 py-5 text-lg font-bold sm:text-xl" data-id="element-102" data-mp="15j77nxhibge8">
          PROVA PILATES PRONTA SENZA RISCHI
        </a>
        <p className="mt-6 inline-block rounded-full border border-emerald-500/40 bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-800" data-id="element-103" data-mp="htmnxcdj4f3w">
          Garanzia soddisfatti o rimborsati
        </p>
      </div>
    </section>;
}